<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" />
        <action-button type="delete" @click="del(classroom.id)" v-if="classroom.id && $can('classroom-delete') && modal != true" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="classroom.name"
                  v-model="classroom.name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('classrooms.name')"
                  :error-messages="errors.collect('classroom.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg6 md6 sm6 xs12>
                <v-autocomplete
                  name="classroom.address_id"
                  v-model="classroom.address_id"
                  class="required-field"
                  v-validate="'required'"
                  :items="addresses"
                  item-text="full_address"
                  item-value="id"
                  :label="$t('classrooms.address_id')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('classroom.address_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="classroom.status"
                  v-model="classroom.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_classroom_status()"
                  :label="$t('classrooms.status')"
                  :error-messages="errors.collect('classroom.status')"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "TaskTypesForm",

  props: ["id", "modal"],

  data() {
    return {
      page_title: "",
      predata: {},
      classroom: {},
      addresses: [],
      dictionary: {
        attributes: {
          "classroom.name": this.$t("classrooms.name"),
          "classroom.address_id": this.$t("classrooms.address_id"),
          "classroom.status": this.$t("classrooms.status")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.classroom, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    axios.get(this.API_URL + "addresses?show_all=true").then((res) => {
      this.addresses = res.data.data

      if (!this.id) {
        this.page_title = this.$t("classrooms.new_classroom")
        this.classroom = {
          address_id: this.addresses.length == 1 ? this.addresses[0].id : null,
          status: this.$getDefaultDropdown(this.$dd_classroom_status())
        }

        // JSON stringify and parse to remove variable reactiveness
        this.predata = JSON.parse(JSON.stringify(this.classroom))
      } else {
        this.title = this.$t("classrooms.update_title")

        axios
          .get(this.API_URL + "classroom/" + this.id)
          .then((res) => {
            this.classroom = res.data.data

            // JSON stringify and parse to remove variable reactiveness
            this.predata = JSON.parse(JSON.stringify(this.classroom))

            this.page_title = this.$t("classrooms.edit_classroom", {
              name: this.classroom.name
            })
          })
          .catch((err) => console.log(err))
      }
    })
  },

  methods: {
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.classroom.id) {
              // Create
              axios
                .post(this.API_URL + "classroom", {
                  name: this.classroom.name,
                  address_id: this.classroom.address_id,
                  status: this.classroom.status,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.classroom = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.classroom))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "classroom",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.page_title = vm.$t("classrooms.edit_classroom", {
                          name: vm.classroom.name
                        })
                        vm.$awn.success(vm.$t("global.create_success"))
                        vm.$router.replace(this.BACKEND_URL + `/classrooms/edit/${vm.classroom.id}`).catch(() => {})
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "classroom", {
                  id: this.classroom.id,
                  name: this.classroom.name,
                  address_id: this.classroom.address_id,
                  status: this.classroom.status
                })
                .then((res) => {
                  vm.classroom = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.classroom))

                  vm.page_title = vm.$t("classrooms.edit_classroom", {
                    name: vm.classroom.name
                  })

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "classroom",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "classroom/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/classrooms")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
